import logo from './assets/Logo.png';  // Importa el logo
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
	  <a
          className="App-link"
          href="https://framegonz.com"
          target="_self"
          rel="noopener noreferrer"
        >
          <img src={logo} className="App-logo" alt="logo" />
        </a>
        <p>
          Bienvenido a framegon.es
        </p>
        <a
          className="App-link link-position"
          href="https://framegon.es:8443/?utm_campaign=plesk_site_default_page_js"
          target="_self"
          rel="noopener noreferrer"
        >
          Acceso
        </a>
      </header>
    </div>
  );
}

export default App;
